module.exports = "/img/hyundai.c04a9aa9.png";